import { isDevMode } from '@angular/core';

import { environment } from '@env/environment';

export const defaultDialogMaxWidth = '520px';
export const defaultDialogMinWidth = '288px';
export const defaultDialogWidth = '90dvw';
export const defaultDialogMaxHeight = '90dvh';
export const isServiceWorkerEnabled = !isDevMode() && environment.production;
export const serviceWorkerSetupDelay = 15 * 1000; // 15s
